import { useQuery, useMutation } from 'react-query'
import client, { deleteclient, patchclient } from './api-client';

const parcelQueryConfig = {
  staleTime: 1000 * 60 * 60,
  cacheTime: 1000 * 60 * 60,
}

async function fetchPerformanceMap(parcel_id) {
  const data = await client(`performance_map/?parcel_id=${parcel_id}`)
  return data
}

export function usePerformanceMap(parcel_id) {
  return useQuery(['performance_map', parcel_id], () => fetchPerformanceMap(parcel_id), {
    refetchAllOnWindowFocus: false,
    enabled: false,
    ...parcelQueryConfig
  });
}